/*
 * Copyright (c) Worldline 2023.
 */

export const ExternalEvidenceStatus = {
    toUpload: 'TO_UPLOAD',
    toCrop: 'TO_CROP',
    toProcess: 'TO_PROCESS',
    toValidate: 'TO_VALIDATE',
    processing: 'PROCESSING',
    completed: 'COMPLETED',
    error: 'ERROR',
    errTech: 'ERR_TECH'
}